var _path, _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPencilLines = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "currentcolor",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12.358 3.483a.236.236 0 0 0-.333 0L5.288 10.22l-.61 2.437 2.438-.61 6.737-6.736a.236.236 0 0 0 0-.333l-1.495-1.495Zm-1.333-1a1.65 1.65 0 0 1 2.333 0l1.495 1.495a1.65 1.65 0 0 1 0 2.333l-6.875 6.875a.706.706 0 0 1-.329.186l-3.77.943a.707.707 0 0 1-.858-.857l.943-3.771a.707.707 0 0 1 .186-.329l6.875-6.875Z",
  clipRule: "evenodd"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 7,
  height: 1.5,
  x: 1,
  y: 2,
  rx: 0.75
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 4.5,
  height: 1.5,
  x: 1,
  y: 5,
  rx: 0.75
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 1.5,
  x: 1,
  y: 8,
  rx: 0.75
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPencilLines);
export default ForwardRef;